import React from 'react';
import { Link } from "gatsby"

import AboutImg from "../../assets/images/about-img2.png"
import Shape15 from "../../assets/images/shape/shape15.png"

const AboutUsSection = () => {
    return (
        <div className="about-area pb-100">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-img">
                            <img src={AboutImg} alt="AI-Powered Transformation" />
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 col-md-6">
                        <div className="about-content">
                            <div className="text">
                                <p></p>
                                <span className="sub-title">AI-Powered Transformation</span>
                                <h2>On a mission to democratize the access to AI.</h2>
                                <br></br>
                                <p align = "left">At <b>cimplify.ai</b>, we are on a mission to democratize the access to AI solutions and make them accessible to the widest possible audience. </p> 
                                <p>We strive to empower everyone – from businesses large and small, to individuals – to benefit from the transformative power of AI. We are committed to providing powerful tools, resources and support to help unlock the potential of AI, and to create a fairer, more equitable world. </p> 




                              
                        
                                
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="shape15">
                <img src={Shape15} alt="Shape" />
            </div>
        </div>
    )
}

export default AboutUsSection;